/**
 * Rules Hooks
 * Jotai atoms and hooks for rules listing (used by shadow mode filters, metadata panels, etc.)
 */

import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { ruleService } from '@/services/rule.service';

const rulesQueryAtom = atomWithQuery(() => ({
  queryKey: ['rules'],
  queryFn: ruleService.getRules
}));

export function useRules() {
  const [query] = useAtom(rulesQueryAtom);
  return query;
}

